"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftCancellationDto = instanceOfShiftCancellationDto;
exports.ShiftCancellationDtoFromJSON = ShiftCancellationDtoFromJSON;
exports.ShiftCancellationDtoFromJSONTyped = ShiftCancellationDtoFromJSONTyped;
exports.ShiftCancellationDtoToJSON = ShiftCancellationDtoToJSON;
exports.ShiftCancellationDtoToJSONTyped = ShiftCancellationDtoToJSONTyped;
const ShiftCancellationReason_1 = require("./ShiftCancellationReason");
/**
 * Check if a given object implements the ShiftCancellationDto interface.
 */
function instanceOfShiftCancellationDto(value) {
    return true;
}
function ShiftCancellationDtoFromJSON(json) {
    return ShiftCancellationDtoFromJSONTyped(json, false);
}
function ShiftCancellationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'reason': json['reason'] == null ? undefined : (0, ShiftCancellationReason_1.ShiftCancellationReasonFromJSON)(json['reason']),
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}
function ShiftCancellationDtoToJSON(json) {
    return ShiftCancellationDtoToJSONTyped(json, false);
}
function ShiftCancellationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'reason': (0, ShiftCancellationReason_1.ShiftCancellationReasonToJSON)(value['reason']),
        'comment': value['comment'],
    };
}
//# sourceMappingURL=ShiftCancellationDto.js.map